import { combineReducers } from 'redux';

import { SET_RESET_PASSWORD_EMAIL_STATUS } from '../actions/forgotPassword';
import { SET_SOFT_ACCOUNT_EMAIL_STATUS } from '../actions/softAccount';
import { SET_SIGNUP_SECOND_STEP } from '../actions/lookup';
import { SET_TOS_SOCIAL_STATUS, SET_TOS_SOCIAL_ACCEPTED } from '../actions/tos';
import {
    SET_PASSWORDLESS_EMAIL_STATUS,
    SET_PASSWORDLESS_LOGIN_STATUS,
} from '../actions/passwordless';

const resetPasswordEmailStatus = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_RESET_PASSWORD_EMAIL_STATUS) {
        nextState = payload;
    }
    return nextState;
};

const passwordlessEmailStatus = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_PASSWORDLESS_EMAIL_STATUS) {
        nextState = payload;
    }
    return nextState;
};

const passwordlessLoginStatus = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_PASSWORDLESS_LOGIN_STATUS) {
        nextState = payload;
    }
    return nextState;
};

const softAccountEmailStatus = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_SOFT_ACCOUNT_EMAIL_STATUS) {
        nextState = payload;
    }
    return nextState;
};

const signUpSecondStep = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_SIGNUP_SECOND_STEP) {
        nextState = payload;
    }
    return nextState;
};

const tosSocialStatus = (state = false, { type, payload = '' }) => {
    let nextState = state;

    if (type === SET_TOS_SOCIAL_STATUS) {
        nextState = payload;
    }
    return nextState;
};

const tosSocialAccepted = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_TOS_SOCIAL_ACCEPTED) {
        nextState = payload;
    }
    return nextState;
};

export default combineReducers({
    resetPasswordEmailStatus,
    softAccountEmailStatus,
    signUpSecondStep,
    tosSocialStatus,
    tosSocialAccepted,
    passwordlessEmailStatus,
    passwordlessLoginStatus,
});
